import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IVideoCategory } from '../models/responseModels'

export class GetVideoCategoryListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/video-category/list',
      requesterInfo,
    })
  }

  public async getVideoCategories(): Promise<IVideoCategory[]> {
    return await this.getAsync<IVideoCategory[]>()
  }
}
